<template>  
  <map-simulation ref="map" :uiid="uiid" maptype="simulation" ></map-simulation>
</template>
<script>  
  import MapSimulation from '@/components/map/Map'

  export default {
    name: 'MissionMap',    
    components:{MapSimulation},    
    props:{
      uiid:{
          type: String,
          default: 'map_global'
      }    
    },
    methods:{
      updateSize() {        
        if(!this.$refs.map) this.$nextTick(this.updateSize)
        else this.$refs.map.updateSize()            
      }
    }
  }
</script>
